<template>
  <div class="animated fadeIn">
    
    <!-- HEADER NAVIGATION START -->
    <div class="header-homepage">
      <b-navbar type="light" class="d-md-down-none">
        
      <b-link class="navbar-brand" to="/">
        <img class="navbar-brand-full" src="/img/brand/logo.svg" width="240" height="75" alt="Cashbac UI">
      </b-link>
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="/welcome">Getting Started</b-nav-item>
          <b-nav-item href="/foundations">Foundations</b-nav-item>
          <b-nav-item href="/components">Components</b-nav-item>
          <b-nav-item href="/pages">Sample Page</b-nav-item>
        </b-navbar-nav>
      </b-navbar>
    </div>
    <!-- HEADER NAVIGATION END -->
    <div class="container-fluid">
    <b-alert variant="primary" show dismissible class="header-homepage">
      Welcome to Cashbac UI! Please note: <b>This project no longer maintained</b>.
    </b-alert>
    
      <b-card class="card card-homepage">
          
   
    
      <div bg-variant="primary" text-variant="white" class="hero-homepage hero-fluid">
        
          <div class="">
            
          </div>
          <div class="hero-content">
            <h1>Cashbac UI</h1>
          
            <p class="sub-headline">
              Our design system helps us work <br>
              together to build a great experience <br>
              for all of Cashbac’s merchants.
            </p>                   
            <div class="spacer1"></div>
            <div class="spacer1"></div>
            <div class="spacer1"></div>
            <div class="spacer1"></div>
            <p></p>
          </div>
      
      </div>

          <h1>Guide</h1>
          <p class="sub-headline">
            Check out these practical guides to help you <br>
            understand how to design for the Cashbac Web <br>
            platform using Cashbac UI.
          </p>
          <div class="spacer1"></div>

          <div class="spacer1"></div>
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <h4>Foundations</h4>
              <p>
                Know the foundation how to use Cashbac UI, to build web products at Cashbac.
              </p>
              <b-link to="/foundations">Get Started</b-link>
              <div class="spacer1"></div>
            </div>
            <div class="col-md-3 col-sm-12">
              <h4>Components</h4>
              <p>
                Get to know components in Cashbac UI. Please read one by one carefully :)
              </p>
              <b-link to="/components">See Components</b-link>
              <div class="spacer1"></div>
            </div>
            <div class="col-md-3 col-sm-12">
              <h4>Page Sample</h4>
              <p>
                Various page samples that developed for best practice using Cashbac UI.
              </p>
              <b-link to="/pages">See Page Sample</b-link>
              <div class="spacer1"></div>
            </div>
            <div class="col-md-3 col-sm-12">
              <h4>Roadmap</h4>
              <p>
                Current progress, next quarter plans and future dreams. All plans in one roof.
              </p>
              <b-link to="/roadmap">See Roadmap</b-link>
              <div class="spacer1"></div>
            </div>
          </div>
          <div class="spacer1"></div>

          <div class="spacer1"></div>

          <b-row>
          <b-col sm="6">
          <b-card class="lg-2 md-2 sm-1 card-in-card-blue">
            <h6>What's New?</h6>
            <h5>Cashbac UI 0.4.7</h5>
            <p>
            A new look and feel, with an updated color palette, icons, and more. A reduction to our bundle size and accessibility features to make sure that the experiences you create work for everyone.
            </p>
            <b-link to="/roadmap">Read all Cashbac UI updates</b-link>
          </b-card>
          </b-col>
          <b-col sm="6">
          <b-card class="lg-2 md-2 sm-1 2 card-in-card-blue">
            <h6>Blog, Post, Talks, and Events</h6>
            <b-link></b-link>
            <br>

            <div class="d-flex">   
              <img 
                src="img/avatars/6.jpg"
                class="img-avatar image-in-updates"
                alt="Indra Avatar" />
              <span class="text-in-updates">
                <b-link href="https://www.instagram.com/p/B88EjGuA2N6/">
                “Ngobrolin UI/UX Design dengan serba-serbi di dalamnya”
                </b-link>
                <p class=name-in-updates>Indra Maulana - UI/UX Designer</p>
              </span>
            </div>
            <br>
            <div class="d-flex">   
              <img 
                src="img/avatars/6.jpg"
                class="img-avatar image-in-updates"
                alt="Daeng Avatar" />
              <span class="text-in-updates">
                <b-link href="https://www.instagram.com/p/B2_IEpHAp1Y/">
                How to Build a User-Centric Information Architecture
                </b-link>
                 <p class=name-in-updates>Daeng Muhammad Feisal - UI/UX Designer</p>
              </span>
            </div>
            
            
          </b-card>
          </b-col>
          </b-row>

          <div class="spacer1"></div>
          <hr>
          
          <div class="spacer1"></div>
          
          <h1>Resources</h1>
          <p class="sub-headline">
          Downloads, links, and third-party tools to help you <br>
          and your teams learn, draft, design,<br>
          and build products for Cashbac.
          </p>
          <div class="spacer1"></div>
          <a href="/brand">Brand Guidelines</a>
          <br>
          <a>Voice and Style<b-badge class="m-1" pill variant="primary">WIP</b-badge></a>
          <br>
          <a>Illustration<b-badge class="m-1" pill variant="primary">WIP</b-badge></a>
      </b-card>
    </div>
    <div class="header-homepage">
      <b-navbar type="light" class="d-md-down-none">
        <b-navbar-nav>
          <b-nav-item href="/roadmap">What's New? <b-badge class="m-1" pill variant="success">0.4.7</b-badge></b-nav-item>
          <b-nav-item href="/credit">Credit</b-nav-item>
          <b-nav-item href="https://cashbac.com">Cashbac Web</b-nav-item>
          <b-nav-item href="https://github.com/cashbacdesign">Cashbac Design Team</b-nav-item>
        </b-navbar-nav>
        <div class="ml-auto">
          <span class="ml-1"> 2019 - 2020 &copy; </span>
          <a href="https://dae.ng" target="_blank" class="footer-link-black">Daeng Muhammad Feisal</a>
        </div>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Homepage'
}
</script>
